module.exports = __webpack_public_path__ + "img/thread1.af058c70.png";